(function() {
  if (window.QuickBuyInitialized) return;
  window.QuickBuyInitialized = true;

  class QuickBuy extends HTMLElement {
    constructor() {
      super();
      this.quickbuyButton = this.querySelector(".quick-add__hover");
      this.variants = this.querySelector(".variants");
      this.isOpen = false;
      this.forms = this.querySelectorAll('form[action="/cart/add"]');
      
      this.updateMobileState = this.updateMobileState.bind(this);
      this.updateMobileState();

      window.addEventListener('resize', this.debounce(this.updateMobileState, 250));

      this.addEventListener("click", this.handleClick.bind(this));
      this.addEventListener("mousedown", this.handleMouseDown.bind(this));
      this.addEventListener("mouseup", this.handleMouseUp.bind(this));

      this.forms.forEach(form => {
        form.addEventListener('submit', this.handleSubmit.bind(this));
      });
    }

    debounce(func, wait) {
      let timeout;
      return function executedFunction(...args) {
        const later = () => {
          clearTimeout(timeout);
          func(...args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
      };
    }

    updateMobileState() {
      const wasMobile = this.isMobile;
      this.isMobile = window.innerWidth < 1024;

      if (wasMobile !== this.isMobile) {
        if (this.isMobile) {
          this.showVariants();
          if (this.quickbuyButton) {
            this.quickbuyButton.style.display = "none";
          }
          this.removeDesktopListeners();
        } else {
          this.hideVariants();
          if (this.quickbuyButton) {
            this.quickbuyButton.style.display = "block";
          }
          this.addDesktopListeners();
        }
      }
    }

    addDesktopListeners() {
      if (this.quickbuyButton) {
        this.quickbuyButton.addEventListener("mouseenter", this.showVariants.bind(this));
      }
      this.addEventListener("mouseleave", this.hideVariants.bind(this));
      document.addEventListener("click", this.handleOutsideClick.bind(this));
    }

    removeDesktopListeners() {
      if (this.quickbuyButton) {
        this.quickbuyButton.removeEventListener("mouseenter", this.showVariants.bind(this));
      }
      this.removeEventListener("mouseleave", this.hideVariants.bind(this));
      document.removeEventListener("click", this.handleOutsideClick.bind(this));
    }

    handleSubmit(event) {
      event.preventDefault();
      const form = event.target;
      const formData = new FormData(form);

      formData.append('sections', 'grim-drawer');
      formData.append('sections_url', window.location.pathname);

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { cart: data }
        }));
        
        if (!this.isMobile) {
          this.hideVariants();
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    }

    toggleVariants(event) {
      event.preventDefault();
      event.stopPropagation();
      this.isOpen = !this.isOpen;
      this.updateVariantsVisibility();
    }

    showVariants(event) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      this.isOpen = true;
      this.updateVariantsVisibility();
    }

    hideVariants() {
      if (this.isMobile) return;
      
      this.isOpen = false;
      this.updateVariantsVisibility();
    }

    updateVariantsVisibility() {
      if (this.isOpen || this.isMobile) {
        this.variants.style.display = "flex";
        this.variants.style.opacity = "1";
        if (this.quickbuyButton && !this.isMobile) {
          this.quickbuyButton.style.visibility = "hidden";
        }
      } else {
        this.variants.style.display = "none";
        this.variants.style.opacity = "0";
        if (this.quickbuyButton) {
          this.quickbuyButton.style.visibility = "visible";
        }
      }
    }

    handleClick(event) {
      if (!event.target.closest('.quick-add-btn')) {
        event.preventDefault();
        event.stopPropagation();
      }
    }

    handleMouseDown(event) {
      if (!event.target.closest('.quick-add-btn')) {
        event.preventDefault();
        event.stopPropagation();
      }
    }

    handleMouseUp(event) {
      if (!event.target.closest('.quick-add-btn')) {
        event.preventDefault();
        event.stopPropagation();
      }
    }

    handleOutsideClick(event) {
      if (!this.isMobile && !this.contains(event.target)) {
        this.isOpen = false;
        this.updateVariantsVisibility();
      }
    }
  }

  if (!customElements.get('quick-buy')) {
    customElements.define("quick-buy", QuickBuy);
  }
})();